import React from 'react';

const FeatureList = ({ features }) => {
  return (
    <ul className="gap-y-3 mb-6">
      {features.map((feature, index) => (
        <li key={index} className="flex gap-2 items-start">
          <div className="mt-2 w-1.5 h-1.5 bg-gray-900 rounded-full flex-[shrink]" />
          <div className="text-sm leading-5 text-gray-700 max-sm:text-sm max-sm:leading-5">
            <span className="font-semibold">{feature.title}</span>
            {feature.description}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default FeatureList;
